export default function VeteransDayLuncheon2023() {
	return (
		<>
			<header className="py-5">
				<div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
					<h2 className="text-3xl font-bold leading-tight text-gray-900">
						Veterans Day Luncheon
					</h2>
				</div>
			</header>
			<div className="px-4 pt-4 pb-8">
				<div className="mx-auto max-w-6xl text-lg sm:px-6 lg:px-8">
					<img
						src="/images/ebhs/events/2023-veterans-day-luncheon.jpg"
						alt="poster for 2023 presentation by lorraine slomovic"
						className="w-full py-3"
					/>
				</div>
			</div>
		</>
	)
}
